import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Label from '@zg-rentals/multibrand-ui/lib/Label';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import CurrencyInput from '@zg-rentals/multibrand-ui/lib/CurrencyInput';
import Section from '@rental-manager/components/Section';
import HelpToolTip from '@rental-manager/pages/Onboarding/HelpToolTip';
import FaqComponent from '@common/components/FaqComponent';
import SpinnerContainer from '@common/components/SpinnerContainer';
import { centsToDollars, dollarsToCents } from '@common/paymentsUtils/currencyUtils';
import FaqConstants from '@rental-manager/constants/FaqConstants';
// TODO: Move validation to a common place
import { validateAllInputs } from '@rental-manager/pages/Onboarding/RentAmountPage/validation';
import REQUEST_STATUS from '@common/constants/requestStatus';

type Props = {
  rentAmount: number;
  onSubmit: ({ rentAmount }) => void;
  editMode: boolean;
  requestStatus?: string;
  onCancel: () => void;
};

type State = {
  value: string;
  error: string;
  isLoading: boolean;
};

class NewTenantRentAmount extends React.Component<Props, State> {
  static defaultProps = {
    rentAmount: 0,
    onSubmit: () => {},
    editMode: false,
  };

  constructor(props) {
    super(props);
    const { rentAmount } = props;
    this.state = {
      value: rentAmount ? centsToDollars(rentAmount) : '',
      error: '',
      isLoading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.rentAmount && this.props.rentAmount !== prevProps.rentAmount) {
      const value = centsToDollars(this.props.rentAmount);
      // oxlint-disable-next-line react/no-did-update-set-state -- guarded by a prop-change check, not unconditional; preserving existing behavior
      this.setState({
        value,
        error: '',
        isLoading: false,
      });
    }

    if (prevProps.requestStatus !== REQUEST_STATUS.SUCCESS && this.props.requestStatus === REQUEST_STATUS.SUCCESS) {
      // oxlint-disable-next-line react/no-did-update-set-state -- guarded by a prop-change check, not unconditional; preserving existing behavior
      this.setState({ isLoading: false });
    }
  }

  onChangerentAmount = (e): void => {
    const rentAmount = e.target.value;
    this.setState({
      value: rentAmount,
      error: '',
    });
  };

  onSubmit = () => {
    const { value } = this.state;

    if (!validateAllInputs(this)) {
      return { error: true };
    }
    return this.props.onSubmit({ rentAmount: dollarsToCents(value) });
  };

  render(): React.ReactNode {
    const { editMode } = this.props;
    const { value, error, isLoading } = this.state;
    return (
      <>
        {isLoading && <SpinnerContainer />}
        <Section>
          <Text type="h3">How much is your base monthly rent?</Text>
        </Section>
        <Section>
          <Label className="flexDisplay" data-auto-test-id="monthly-amount-label">
            Base monthly amount
            <HelpToolTip>
              Enter the amount that is due every month. Don&apos;t include prorated rent or move-in costs, such as a
              security deposit.
            </HelpToolTip>
          </Label>
          <CurrencyInput
            data-statekey="rentAmount"
            noLabel
            value={value}
            error={error}
            onChange={this.onChangerentAmount}
            onBlur={this.onChangerentAmount}
            onFocus={this.onChangerentAmount}
            data-auto-test-id="monthly-amount-input"
          />
        </Section>
        <Section>
          <SpacerRow>
            <FaqComponent.Landlord faqs={FaqConstants.ONBOARDING_V2.RENT_AMOUNT_PAGE} />
          </SpacerRow>
        </Section>
        <Section>
          <Button type="primary" onClick={this.onSubmit} full>
            {editMode ? 'Update' : 'Continue'}
          </Button>
        </Section>
        {editMode && (
          <Section>
            <Button type="tertiary" full data-statekey="Cancel" onClick={this.props.onCancel}>
              Cancel
            </Button>
          </Section>
        )}
      </>
    );
  }
}

export default NewTenantRentAmount;
